import { init } from '@sentry/nextjs'

init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: `${process.env.VUE_APP_GIT_SHA}-${process.env.NEXT_PUBLIC_ENV}`,
  tracesSampleRate: process.env.NEXT_PUBLIC_ENV === 'production' ? 0.2 : 1.0,
})
